import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TableCardComponent } from './table-card.component';
import { TooltipModule } from '../../notes/tooltip/tooltip.module';
import { ButtonModule } from '../../notes/button/button.module';
import { MessageBannerModule } from '../../notes/message-banner/message-banner.module';
import { ModelAttributeModule } from '../../notes/model-attribute/model-attribute.module';

@NgModule({
  declarations: [TableCardComponent],
  exports: [TableCardComponent],
  imports: [
    CommonModule,
    TooltipModule,
    ButtonModule,
    MessageBannerModule,
    ModelAttributeModule,
  ],
})
export class TableCardModule {}

export * from './table-card.types';
